module.exports = __webpack_public_path__ + "img/backward_arrow.53875d0.png";